// extracted by mini-css-extract-plugin
export default {"content-wrapper":"PricingPlan_content-wrapper__B38BH"};